import { render } from "./VartaBlack.vue?vue&type=template&id=aa4ed588&scoped=true&class=banner"
import script from "./VartaBlack.vue?vue&type=script&lang=js"
export * from "./VartaBlack.vue?vue&type=script&lang=js"

import "./VartaBlack.vue?vue&type=style&index=0&id=aa4ed588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4ed588"]])

export default __exports__